export const searchParamNames = {
	emailConfirmationToken: 'token',
} as const
